import { Action } from '@ngrx/store';

import { TokenState } from '../shared-state.interface';
import { TokenActions, TokenActionTypes } from './token.actions';

export const emptyTokenState: TokenState = {
    userTokens: { access_token: '', expires_in: 0, refresh_token: '', token_type: '' }
};

export const initialTokenState: TokenState = emptyTokenState;

export function tokenReducer(state = initialTokenState, action: Action): TokenState {
    const specificAction: TokenActions = action as TokenActions;
    switch (specificAction.type) {
        case TokenActionTypes.Set:
            return { ...state, userTokens: specificAction.payload };

        case TokenActionTypes.Unset:
            return { ...emptyTokenState };

        default:
            return state;
    }
}
